import { FormattedMessage } from "react-intl";

export const ErrorCode = {
  1199: "email_has_been_registered",
  1303: "code_is_incorrect",
  1301: "email_has_been_verified",
  1203: "password_is_incorrect",
  1502: "otp_is_expired",
  1601: "please_login",
  1603: "old_password_incorrect",
  1204: "account_not_existed",
  1503: "the_otp_is_incorrect",
  1201: "account_has_not_been_verified",
  1298: "there_are_error_occured",
  5192: "you_dont_have_permission",
  1499: "the_field_cannot_be_blank",
  5399: "email_has_been_registered",
  // Account: update-profile (9)
  1901: "please_login",
  1902: "phone_already_in_use",
  // Account: request-email-change (10)
  11001: "please_login",
  11002: "invalid_email_address",
  11003: "password_is_incorrect",
  11004: "email_unchanged",
  11005: "email_has_been_registered",
  // Account: confirm-email-change (11)
  11101: "please_login",
  11102: "no_pending_email_change",
  11103: "otp_is_expired",
  11104: "the_otp_is_incorrect",
  11105: "email_has_been_registered",
  // Account: delete-account (12)
  11201: "please_login",
  11202: "password_is_incorrect",
  // Account: request-phone-verification (13)
  11301: "please_login",
  11302: "phone_verify_needs_premium",
  11303: "phone_verify_sms_failed",
  // Account: confirm-phone-verification (14)
  11401: "please_login",
  11402: "phone_verify_no_code",
  11403: "otp_is_expired",
  11404: "the_otp_is_incorrect",
  // Billing: create-order (B1) — invalid promo/referral code
  B102: "invalid_code",
  B103: "code_already_used",
  // Google login (auth/google) — banned account
  8105: "account_blocked",
};
